import React, { Fragment } from "react";

import Banner from "../../../utils/Banner";
import GetToTeach from "../../layout/sabuj/GetToTeach";
import Card from "./Card";

const ContactIndex = () => {
  return (
    <Fragment>
      <Banner>contact</Banner>
      <Card />
      <GetToTeach />
    </Fragment>
  );
};

export default ContactIndex;
